export const imagePath = {
  appLogo: require("../assets/images/yug_mantra_logo.png"),
  whiteLogo: require("../assets/images/yug_mantra_logo_white.png"),
  background: require('../assets/images/background.png'),
  direction: require('../assets/images/direction.png'),
  question: require('../assets/images/question.png'),
};